export enum CustomDataAttributeCategory {
  Profile = 'profile',
  PaymentRequest = 'paymentrequest',
  Transaction = 'transaction',
  Receipt = 'receipt',
  Invoice = 'invoice',
  None = 'none',
  Expense = 'expense',
  Deposit = 'deposit',
  Campaign = 'campaign',
  Survey = 'survey', // FUTURE USE
}
